<template>
  <div>
      <Row>
        <Col span="12" class="info-item">
          <span>用户ID:</span>
          <span>{{baseInfo.user_id}}</span>
        </Col>
        <Col span="12" class="info-item">
          <span>昵称:</span>
          <span>{{baseInfo.nick_name}}</span>
        </Col>
        <Col span="12" class="info-item">
          <span>手机号:</span>
          <span class="important-word">{{baseInfo.mobile}}</span>
        </Col>
        <Col span="12" class="info-item">
          <span>站点数量:</span>
          <span class="important-word">{{baseInfo.station_num}}</span>
        </Col>
        <Col span="12" class="info-item">
          <span>充值总额:</span>
          <span class="important-word">{{baseInfo.total_promote_balance}}</span>
        </Col>
        <Col span="12" class="info-item">
          <span>余额:</span>
          <span class="important-word">{{baseInfo.promote_balance}}</span>
        </Col>
        <Col span="12" class="info-item">
          <span>真实姓名:</span>
          <span>{{baseInfo.real_name}}</span>
        </Col>
        <Col span="12" class="info-item">
          <span>身份证号:</span>
          <span>{{baseInfo.id_card}}</span>
        </Col>
        <Col span="12" class="info-item" v-if="baseInfo.company_id === 0">
          <span>推荐上级:</span>
          <span>
            <a @click.stop="reloadPage(baseInfo.pid)" v-if="baseInfo.pid > 0">
              {{baseInfo.pname || ''}}
              <Icon type="ios-search" />
            </a>
          </span>
        </Col>
        <Col span="12" class="info-item">
          <span>注册时间:</span>
          <span>{{baseInfo.create_time}}</span>
        </Col>


      </Row>

      <Tabs>
        <TabPane label="站点列表">
          <pageTable tabelRef="gasTable"
                     :tableTitle="gasTableColumn"
                     :searchData="{}"
                     :tableHeight="300"
                     :defaultSearchParam="{user_id:this.baseInfo.user_id}"
                     tableApi="admin/gas/getPrivateStation"
          >
          </pageTable>
        </TabPane>

        <TabPane label="充值记录">
          <pageTable tabelRef="promoteBalanceTable"
                     :tableTitle="promoteBalanceTableColumn"
                     :searchData="{}"
                     :tableHeight="300"
                     :defaultSearchParam="{user_id:this.baseInfo.user_id,asset_type:'promote_balance'}"
                     tableApi="admin/asset/getUserRecord"
          >
          </pageTable>
        </TabPane>

        <TabPane label="推广列表">
          <pageTable tabelRef="memberTable"
                     :tableTitle="friendColumn"
                     :searchData="{}"
                     :tableHeight="300"
                     :defaultSearchParam="{user_id:this.baseInfo.user_id}"
                     tableApi="admin/user/getMyFriend"
          >
          </pageTable>
        </TabPane>
      </Tabs>

  </div>
</template>

<script>
  import pageTable from "@/components/table/pageTable";
  export default {
    name: "edit",
    components:{pageTable},
    props:{
      user_id:{
        type:Number,
        default: 0
      },
      baseInfo:{
        type:Object,
        default:null
      },
    },
    data(){
      return {
        promoteBalanceTableColumn:[

        ],
        gasTableColumn: [
          {title: 'ID',key: 'station_id',align: "center"},
          {title: '站点名称',key: 'gas_name',align: "left"},
          {title: '地址',key: 'gas_address',align: "center"},
          {title: '油品来源',key: 'private_gas_source',align: "center"},
          {title: '营业时间',align: "center",render:(h,params)=>{
              return h('div',`${params.row.work_start_time} - ${params.row.work_end_time}`)
            }},
          {title: '联系人',key:'contact_user',align: "center"},
          {title: '联系电话',key:'contact_mobile',align: "center"},
          {title: '油价',key: 'price',align: "center",},
          {title: '状态',align: "center",render:(h,params)=>{
              let status = parseInt(params.row.gas_status)
              if (status === 1){
                return h('span','正常')
              }else if(status === 5){
                return h('span',{style:{color:'blue'}},'待审核')
              }else{
                return h('span',{style:{color:'red'}},'禁用')
              }
            }},
        ],
        friendColumn:[
          {title: '用户ID',key: 'user_id',align: "center"},
          {title: '用户类型',key: 'type_name',align: "center"},
          {title: '手机号',key: 'mobile',align: "center"},
          {title: '昵称',key: 'nick_name',align: "center"},
          {title: '注册时间',key: 'create_time',align: "center"},
          {title: '查看',render:(h,params)=>{
              if (params.row.user_type !== 0){
                return h('Button',{props:{type:'primary',size:'small'},on:{click:()=>{this.reloadPage(params.row.user_id)}}},'查看')
              }else {
                return  '';
              }
            }},
        ],
      }
    },
    methods:{
      reloadPage(user_id){
        this.$parent.$parent.reloadPage(user_id)
      }
    },
    mounted() {

    },
    watch:{

    }
  }
</script>

<style scoped lang="less">
  .drawer-footer{
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    background: #fff;
  }

</style>
